import axios from './axios';

let baseUrl = '';
const saveSettings = {};

const init = function(url) {
    // use init to set the baseUrl
    baseUrl = url;

    return saveSettings;
};

saveSettings.getSaveSettings = function () {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl + 'getSaveSettings').then(function (res) {
            let data = res.data;

            resolve(data);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

saveSettings.saveTheSettings = function (settingsData) {
    return new Promise((resolve, reject) => {
        axios.post(baseUrl + 'saveTheSettings', settingsData).then(function (res) {
            let data = res.data;

            resolve(data);

        }).catch(function (error) {
            reject(error.response);
        });
    });
};

export default init;